var map = {
	"./story.ar": [
		1510,
		2006
	],
	"./story.ar.jsx": [
		1510,
		2006
	],
	"./story.de": [
		3677,
		9310
	],
	"./story.de.jsx": [
		3677,
		9310
	],
	"./story.en": [
		6945
	],
	"./story.en.jsx": [
		6945
	],
	"./story.es": [
		7008,
		6387
	],
	"./story.es.jsx": [
		7008,
		6387
	],
	"./story.fr": [
		7508,
		6571
	],
	"./story.fr.jsx": [
		7508,
		6571
	],
	"./story.it": [
		9667,
		5800
	],
	"./story.it.jsx": [
		9667,
		5800
	],
	"./story.ja": [
		5675,
		8436
	],
	"./story.ja.jsx": [
		5675,
		8436
	],
	"./story.ko": [
		8442,
		4501
	],
	"./story.ko.jsx": [
		8442,
		4501
	],
	"./story.nl": [
		398,
		1805
	],
	"./story.nl.jsx": [
		398,
		1805
	],
	"./story.pt-BR": [
		3703,
		8568
	],
	"./story.pt-BR.jsx": [
		3703,
		8568
	],
	"./story.zh-Hans": [
		5994,
		9798
	],
	"./story.zh-Hans.jsx": [
		5994,
		9798
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9493;
module.exports = webpackAsyncContext;